import {
  compose,
  branch,
  renderComponent,
  withProps,
  withHandlers
} from 'recompose'
import { connect } from 'react-redux'
import moment from 'moment'
import _get from 'lodash/get'
import {
  withInitialData,
  codeTypeSelect,
  subscriptionSelect
 } from '../components/hoc'
 import { resetSentRequest } from '../reducers/security-code'
import PATSCodesPage from '../components/PATSCodes'
import PATSValidSubscription from '../components/PATSCodes/WithValidSubscription'

const mapStateToProps = (state, ownProps) => {
  const products = state.products.list.length ? state.products.list : ownProps.products
  const isAuthenticated = state.user.isAuthenticated
  const hasIDSsub = _get(state, 'user.details.ids_exp_date') ?
    moment(state.user.details.ids_exp_date).isAfter(moment()) : false
  const hasPCMsub = _get(state, 'user.details.reprog_exp_date') ?
    moment(state.user.details.reprog_exp_date).isAfter(moment()) : false
  const hasMDARSsub = _get(state, 'user.details.mdars_exp_date') ?
    moment(state.user.details.mdars_exp_date).isAfter(moment()) : false
  const hasSubs = hasIDSsub || hasPCMsub || hasMDARSsub

  return {
    products: products.filter(item => item.product_type && item.product_type.key === 'PATS'),
    showAddPatsTip: !isAuthenticated || (isAuthenticated && !hasSubs )
  }
}

const mapDispatchToProps = dispatch => ({
  resetSentRequest: () => dispatch(resetSentRequest())
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    title: 'common:pats-page',
    contentImage: ''
  }),
  withInitialData,
  subscriptionSelect,
  codeTypeSelect,
  withHandlers({
    handleResetForm: props => () => {
      props.resetSentRequest()
      props.setCodeType('')
    }
  }),
  branch(
    ({ user }) => {
      if (user && user.pats_exp_date) {
        const expDate = moment(user.pats_exp_date)
        return moment().isBefore(expDate)
      }
    },
    renderComponent(PATSValidSubscription)
  )
  )(PATSCodesPage)




// WEBPACK FOOTER //
// ./pages/pats-codes.js